import {
  clampPositiveQuantity,
  discountedRollTotalCents,
  formatMarketMoney
} from "./nd-commerce-rules.js?v=20260922-per-unit-rounding";

function findById(id) {
  return id ? document.getElementById(id) : null;
}

export function initRollVolumeDiscount(root) {
  if (!root || root.dataset.initialized === "true") return root;

  const quantityInput = findById(root.dataset.quantityInputId);
  if (!quantityInput) return root;

  root.dataset.initialized = "true";

  const options = Array.from(root.querySelectorAll("[data-roll-discount-option]"));
  const priceRoot = findById(root.dataset.priceRootId);
  const regularPriceEls = priceRoot ? Array.from(priceRoot.querySelectorAll(".price-item--regular")) : [];
  const salePriceEl = priceRoot?.querySelector(".price-item--sale") || null;
  const priceWrapper = priceRoot?.querySelector(".price") || null;
  const priceSaleWrap = priceRoot?.querySelector(".price__sale") || null;
  const unitPriceCents = Number.parseInt(root.dataset.rollUnitCents || "0", 10) || 0;
  const formatMoney = (cents) =>
    formatMarketMoney(cents, {
      currencyCode: root.dataset.moneyCurrency || "USD",
      locale: root.dataset.moneyLocale || document.documentElement.lang || window.Shopify?.locale
    });

  const dispatchStickyPriceUpdate = () => {
    document.dispatchEvent(
      new CustomEvent("nd:main-price-override", {
        detail: {
          totalCents: discountedRollTotalCents(unitPriceCents, quantityInput.value)
        }
      })
    );
  };

  const updateDisplayedPrice = () => {
    if (!priceRoot || !priceWrapper || !salePriceEl || regularPriceEls.length === 0) return;

    const quantity = clampPositiveQuantity(quantityInput.value);
    const fullPriceCents = unitPriceCents * quantity;
    const discountedCents = discountedRollTotalCents(unitPriceCents, quantity);
    const fullText = formatMoney(fullPriceCents);
    const discountedText = formatMoney(discountedCents);
    const hasDiscount = quantity >= 3;

    if (hasDiscount) {
      priceWrapper.classList.add("price--on-sale");
      regularPriceEls.forEach((el) => {
        // The struck compare-at price omits the currency code; the sale price carries it.
        el.textContent = el.closest("s") ? fullText.replace(/\s[A-Z]{3}$/, "") : fullText;
      });
      salePriceEl.textContent = discountedText;
      priceSaleWrap?.classList.remove("hidden");
      return;
    }

    priceWrapper.classList.remove("price--on-sale");
    regularPriceEls.forEach((el) => {
      el.textContent = fullText;
    });
    salePriceEl.textContent = fullText;
    priceSaleWrap?.classList.remove("hidden");
  };

  const syncActiveOption = () => {
    const quantity = clampPositiveQuantity(quantityInput.value);
    const activeQty = quantity >= 3 ? 3 : 1;

    options.forEach((option) => {
      option.classList.toggle("is-active", Number.parseInt(option.dataset.qty || "0", 10) === activeQty);
    });

    updateDisplayedPrice();
    dispatchStickyPriceUpdate();
  };

  const setQuantity = (nextQuantity) => {
    quantityInput.value = String(nextQuantity);
    quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
    quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
  };

  options.forEach((option) => {
    const activate = () => {
      const optionQty = clampPositiveQuantity(option.dataset.qty || 1);
      const currentQty = clampPositiveQuantity(quantityInput.value);
      const nextQty = optionQty >= 3 ? Math.max(currentQty, 3) : optionQty;
      setQuantity(nextQty);
    };

    option.addEventListener("click", activate);
    option.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      activate();
    });
  });

  quantityInput.addEventListener("input", syncActiveOption);
  quantityInput.addEventListener("change", syncActiveOption);
  syncActiveOption();

  return root;
}

function autoInit() {
  document.querySelectorAll("[data-nd-roll-volume-discount]").forEach((root) => {
    initRollVolumeDiscount(root);
  });
}

if (typeof window !== "undefined") {
  window.NDStorefront = window.NDStorefront || {};
  window.NDStorefront.initRollVolumeDiscount = initRollVolumeDiscount;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", autoInit, { once: true });
  } else {
    autoInit();
  }
}
